//@author: devin

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnChanges,
    OnInit,
    Renderer2,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25EditableAbstract } from "../s25.editable.abstract";

@TypeManagerDecorator("s25-ng-editable-richtext")
@Component({
    selector: "s25-ng-editable-richtext",
    template: `
        @if (this.readOnly) {
            <div
                class="s25-data"
                [innerHTML]="this.val | safeHTML"
                [class.fade-preview]="fadePreview"
                [style.--maxHeight]="maxHeight"
                [style.--fadeHeight]="fadeHeight"
            ></div>
        }

        @if (!this.readOnly) {
            <div>
                <div
                    class="s25-editable-shared-container c-editable-text editable editable-click"
                    (click)="this.editMode()"
                    (keyup.enter)="this.editMode()"
                    (keyup.space)="this.editMode()"
                    tabindex="0"
                >
                    @if (!this.editing) {
                        <div
                            class="s25-editable s25-data"
                            [innerHTML]="this.val | safeHTML"
                            [class.fade-preview]="fadePreview"
                            [style.--maxHeight]="maxHeight"
                            [style.--fadeHeight]="fadeHeight"
                        ></div>
                    }
                </div>
                @if (this.editing) {
                    <div>
                        <s25-ng-rich-text-editor
                            [modelValue]="this.val"
                            [autoFocus]="true"
                            [autoResize]="autoResize"
                            (onEditorContentChange)="this.update($event)"
                        ></s25-ng-rich-text-editor>
                        <div class="aw-button-group">
                            @if (this.hasCancelButton) {
                                <button
                                    class="aw-button aw-button--outline"
                                    (click)="this.cancel()"
                                    (keyup.enter)="this.cancel()"
                                >
                                    {{ this.cancelButtonText }}
                                </button>
                            }
                            @if (this.hasCommitButton) {
                                <button
                                    class="aw-button aw-button--primary"
                                    (click)="this.commit()"
                                    (keyup.enter)="this.commit()"
                                >
                                    {{ this.commitButtonText }}
                                </button>
                            }
                        </div>
                        @if (this.errorMessages) {
                            <div>
                                @for (msg of this.errorMessages; track msg) {
                                    <div class="ngRed ngBold">
                                        {{ msg }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    `,
    styles: `
        .s25-data {
            display: block;
            overflow-wrap: break-word;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableRichtextComponent extends S25EditableAbstract<string> implements OnInit, OnChanges {
    @Input() autoResize: boolean = false;

    getType = () => "richtext";

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
        private zone: NgZone,
        private renderer: Renderer2,
    ) {
        super(elementRef, cd, zone, renderer);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnChanges() {
        this.valChange.emit(this.val);
    }
}
